import axios from 'axios';
import Swal from 'sweetalert2';

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`, // Reemplaza con la URL de tu API
    withCredentials: true,
    xsrfCookieName: 'csrf_cookie_name', // Debe coincidir con $cookieName de CI4
    xsrfHeaderName: 'X-CSRF-TOKEN',     // Debe coincidir con $headerName de CI4
});

// 1. Creamos la variable que va a guardar el logout del contexto
let logoutGlobal = null;

// 2. Creamos una función para que el Contexto nos "inyecte" su logout
export const injectLogout = (logoutFunction) => {
    logoutGlobal = logoutFunction;
};

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response) {
            const status = error.response.status;
            const mensaje = error.response?.data?.message || "Su sesión ha expirado.";

            // 1. SOLO EL 401 EXPULSA AL USUARIO (Token Vencido / Sesión muerta)
            if (status === 401) {
                // Mostramos tu SweetAlert de forma global
                await Swal.fire({
                    icon: "error",
                    title: "¡Sesión Expirada!",
                    text: mensaje,
                    showConfirmButton: true,
                    confirmButtonText: "Ok",
                });
                
                // Borramos la sesión en el Backend de forma segura
                try {
                    await axios.get(`${process.env.REACT_APP_API_URL}/auth/logout`, { withCredentials: true });
                } catch (e) {
                    console.error("Error al limpiar sesión en backend", e);
                }

                // 3. ¡LA MAGIA!: Si el contexto nos pasó el logout, lo ejecutamos.
                // Esto va a limpiar los estados de React y redirigir de forma orgánica.
                if (logoutGlobal) {
                    logoutGlobal();
                } else {
                    // Respaldo por si el contexto todavía no se cargó
                    window.location.hash = '/ionAuthLogin/login';
                }
            } 
            // 2. SI ES 403 (Posible desincronización de CSRF o permisos), solo advertimos en consola y NO matamos la sesión
            else if (status === 403) {
                console.warn("Advertencia 403: Posible desincronización de token CSRF o falta de permisos específicos.");
            }
            // 3. ERRORES DE NEGOCIO O VALIDACIÓN (Ej: Status 400 que lanzas en tus excepciones)
            else if (status === 400) {
                const errorData = error.response?.data;
                await Swal.fire({
                    icon: errorData?.icon || "warning",
                    title: errorData?.title || "¡Atención!",
                    html: errorData?.message || "Ocurrió un error en la solicitud.",
                });
            }
        }

        return Promise.reject(error);
    }
);

export default api;